import React from 'react';
import {Alert, Badge, Select, Table, Tag, Typography} from "antd";
import {formatPrice} from "@/lib/utils/number";

const {Title, Text, Paragraph} = Typography;
const {Option} = Select;

function TopicInstallmentSection({topicData}) {

    // ستون‌های جدول اقساط
    const installmentColumns = [
        {
            title: 'شماره قسط',
            dataIndex: 'sort',
            key: 'sort',
            render: (text) => <Text strong>{text}</Text>,
        },
        {
            title: 'مبلغ (تومان)',
            dataIndex: 'price',
            key: 'price',
            render: (price) => <Text className="text-blue-600 font-bold">{formatPrice(price)}</Text>,
        },
        {
            title: 'تاریخ سررسید',
            dataIndex: 'diff_days',
            key: 'diff_days',
            render: (days) => {
                if (days === 0) return <Tag color="green">همراه با ثبت‌نام</Tag>;
                return <Tag color="blue">{days} روز بعد</Tag>;
            },
        },
        {
            title: 'وضعیت',
            key: 'status',
            render: () => <Badge status="success" text="فعال"/>,
        },
    ];
    return (
        <div>
            <Alert
                message="اطلاعات اقساط"
                description={`مجموع مبلغ اقساط: ${formatPrice(topicData?.data?.data?.installments.reduce((sum, item) => sum + item.price, 0))}`}
                type="info"
                showIcon
                className="mb-4"
            />
            <Table
                columns={installmentColumns}
                dataSource={topicData?.data?.data?.installments}
                rowKey="id"
                pagination={false}
            />
        </div>
    );
}

export default TopicInstallmentSection;